import { render, staticRenderFns } from "./IframeCanvas.vue?vue&type=template&id=1246404a&"
import script from "./IframeCanvas.vue?vue&type=script&lang=ts&"
export * from "./IframeCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports